import React, { useState, useCallback } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Topbar from "../../Components/Topbar/Topbar";
import { initCriteriaStates, type CriterionState } from "./norms/normConfig";
import type { User } from "../../types/user";
import type { AlignmentOutletContext, ContextFormData } from "./AlignmentModule";
import "./AlignmentModule.css";

const emptyContext: ContextFormData = {
  companyName: "", sector: "", size: "",
  countries: [], scope: "",
  mainActivities: [], environmentalImpacts: [], socialProfile: [], criticalSuppliers: [],
  rseFunctions: [], rsePolicies: [], certifications: [], esgIndicators: [],
  ethicsTopics: [], docMaturity: [], dataAvailability: [],
  riskSites: "", esgPriorities: "",
  gri_reportingObjective: "", gri_reportingPeriod: "", gri_externalAssurance: "",
  gri_reportingBoundaries: "", gri_materialityProcess: "",
  gri_materialTopics: [], gri_sectorStandards: "", gri_dataOwners: "",
};

interface Props {
  user: User;
  selectedNorm: string;
  setSelectedNorm: (norm: string) => void;
}

const AlignmentModuleClassic: React.FC<Props> = ({ user, selectedNorm, setSelectedNorm }) => {
  const navigate = useNavigate();
  const [criteriaStates, setCriteriaStates] = useState<Record<string, CriterionState>>(initCriteriaStates);
  const [contextData, setContextData] = useState<ContextFormData>(emptyContext);

  const updateCriterionState = useCallback((id: string, updates: Partial<CriterionState>) => {
    setCriteriaStates((prev) => ({
      ...prev,
      [id]: { ...prev[id], ...updates },
    }));
  }, []);

  const outletContext: AlignmentOutletContext = {
    selectedNorm,
    setSelectedNorm,
    user,
    criteriaStates,
    updateCriterionState,
    contextData,
    setContextData,
  };

  return (
    <div className="am-wrapper">
      <Topbar
        title="Alignement Référentiel"
        userName={user.username}
        onLogout={() => navigate("/login")}
        user={user}
      />
      <main className="am-content">
        <Outlet context={outletContext} />
      </main>
    </div>
  );
};

export default AlignmentModuleClassic;
